// danh sách các cột và detail theo tài khoản từng cột
export default {
  object_alias: [1, 2],
  debit_object_alias: [1, 2],
  justice_decision_alias: [2],
  debit_justice_decision_alias: [2],
  bank_account: [3],
};
